import { List, Map, fromJS } from 'immutable';

export function request(state, { parameters }) {
    let last = state.get('last') || List();
    state = state.set('last', parameters);
    return state;
}
